import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import TagManager from 'react-gtm-module';

import App from './components/App';
import reportWebVitals from './reportWebVitals';

import './styles/reset.css';
import './styles/styles.css';

const tagManagerArgs = {
  gtmId: 'GTM-WP9HBKV',
};
TagManager.initialize(tagManagerArgs);

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
